import BasicInformationStep from '../components/tabs-content/pages/basic-information';
import CustomDetailsStep from '../components/tabs-content/pages/custom-details';
import TraceabilityStep from '../components/tabs-content/pages/traceability';
import GeoLocationStep from '../components/tabs-content/pages/geolocation';
import DocumentsStep from '../components/tabs-content/pages/documents';
import ConfirmationStep from '../components/tabs-content/pages/confirmation';

const steps = [
    {
        title: 'Product Information',
        stepUniqueKey: 'information',
        component: (props) => <BasicInformationStep {...props} />
    },
    {
        title: 'Trade & Customs Details',
        stepUniqueKey: 'custom-details',
        component: (props) => <CustomDetailsStep {...props} />
    },
    {
        title: 'Due Diligence & Traceability',
        stepUniqueKey: 'traceablility',
        component: (props) => <TraceabilityStep {...props} />
    },
    {
        title: 'Geolocation Data',
        stepUniqueKey: 'geolocation',
        component: (props) => <GeoLocationStep {...props} />
    },
    {
        title: 'Documents',
        stepUniqueKey: 'documents',
        component: (props) => <DocumentsStep {...props} />
    },
    {
        title: 'Summary & Confirmation',
        stepUniqueKey: 'confirmation',
        component: (props) => <ConfirmationStep {...props} />
    }
];

export {
    steps
}